module.exports = __webpack_public_path__ + "./fonts/9745415b8a2a8b9a2480a12f7e2d3ad3.ttf";